import * as React from "react";
import {db} from "../../firebase";
import {withAuthorization} from "../../firebase/withAuthorization";
import {GifList} from "../../pills/gifs/gifList";
import {GifUpdateForm} from "../../pills/gifs/gifUpdateForm";
import {Modal, Button, Icon} from 'semantic-ui-react'


class HomeComponent extends React.Component {
    constructor(props: any) {
        super(props);

        this.state = {
            gifs: null,
            tags: null,
            currentGif: null,
            modalUpdateOpen: false,
            modalDeleteOpen: false
        };

        this.handleOpenUpdateModal = this.handleOpenUpdateModal.bind(this)
        this.handleOpenDeleteModal = this.handleOpenDeleteModal.bind(this)
        this.handleCloseUpdateModal = this.handleCloseUpdateModal.bind(this)
        this.handleGifUpdated = this.handleGifUpdated.bind(this)
    }

    public componentWillMount() {
        db.onceGetGifs().then(snapshot =>
            this.setState(() => ({gifs: snapshot.val()}))
        );
        db.onceGetTags().then(snapshot =>
            this.setState(() => ({tags: snapshot.val()}))
        );
    }

    handleCloseUpdateModal() {
        this.setState(() => ({
            modalUpdateOpen: false,
        }))
    }

    handleOpenUpdateModal(gif: any) {
        this.setState(() => ({
            modalUpdateOpen: true,
            currentGif: gif
        }))
    }

    handleGifUpdated() {
        db.onceGetGifs().then(snapshot =>
            this.setState(() => ({
                gifs: snapshot.val(),
                modalUpdateOpen: false
            }))
        );
    }

    handleOpenDeleteModal(gif: any) {
        this.setState(() => ({
            modalDeleteOpen: true,
            currentGif: gif
        }))
    }


    handleDeleteClose = () => this.setState({modalDeleteOpen: false})

    onDelete(gif) {
        db.doDeleteGif(gif.id).then(() => {
            console.log("Category Deleted")
            db.onceGetGifs().then(snapshot =>
                this.setState(() => ({gifs: snapshot.val(), modalDeleteOpen: false}))
            );
        });
    }

    public render() {
        const {gifs, tags, currentGif, modalDeleteOpen, modalUpdateOpen}: any = this.state;

        return (
            <div>
                <Modal
                    open={modalUpdateOpen}>
                    <Modal.Header>Update Gif</Modal.Header>
                    <Modal.Content>
                        <GifUpdateForm onGifUpdated={this.handleGifUpdated}
                                       handleCloseModal={this.handleCloseUpdateModal} currentGif={currentGif}
                                       tags={tags}/>
                    </Modal.Content>
                </Modal>
                <Modal
                    open={modalDeleteOpen}>
                    <Modal.Header>Delete Gif</Modal.Header>
                    <Modal.Content>
                        Are you sure you want to delete this Gif?
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='green' onClick={this.handleDeleteClose}>
                            <Icon name='remove'/> No
                        </Button>
                        <Button color='red' onClick={() => this.onDelete(currentGif)}>
                            <Icon name='checkmark'/> Yes
                        </Button>
                    </Modal.Actions>
                </Modal>
                {!!gifs && <GifList handleDelete={this.handleOpenDeleteModal} handleUpdate={this.handleOpenUpdateModal}
                                    gifs={gifs}/>}
            </div>
        );
    }
}

const authCondition = (authUser: any) => !!authUser;

export const Home = withAuthorization(authCondition)(HomeComponent);



// WEBPACK FOOTER //
// ./src/pages/Home/index.tsx